export default __webpack_public_path__ + "14daf2309b4c73146707ac14a67208a7.webp";